import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  errorApiRef,
  fetchApiRef,
  identityApiRef,
  storageApiRef,
} from '@backstage/core-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { UserSettingsStorage } from '@backstage/plugin-user-settings';
import { signalApiRef } from '@backstage/plugin-signals-react';

const techRadarData = {
  title: 'Platform Observability Tech Radar',
  quadrants: [
    { id: '1', name: 'Languages & Frameworks' },
    { id: '2', name: 'Platforms & Services' },
    { id: '3', name: 'Delivery & Tooling' },
    { id: '4', name: 'Security & Governance' },
  ],
  rings: [
    { id: 'adopt', name: 'ADOPT', color: '#5ba300' },
    { id: 'trial', name: 'TRIAL', color: '#009eb0' },
    { id: 'assess', name: 'ASSESS', color: '#f2c037' },
    { id: 'hold', name: 'HOLD', color: '#d66b6b' },
  ],
  entries: [
    {
      id: 'typescript',
      key: 'typescript',
      title: 'TypeScript',
      quadrant: '1',
      description: 'Primary language for internal tooling and web services.',
      url: 'https://www.typescriptlang.org/',
      timeline: [
        {
          ringId: 'adopt',
          date: new Date('2026-01-01'),
          moved: 0,
          description: 'Core engineering language.',
        },
      ],
    },
    {
      id: 'backstage',
      key: 'backstage',
      title: 'Backstage',
      quadrant: '2',
      description: 'Internal developer portal for platform discoverability.',
      url: 'https://backstage.io/',
      timeline: [
        {
          ringId: 'trial',
          date: new Date('2026-01-01'),
          moved: 1,
          description: 'Rolling out as the platform entry point.',
        },
      ],
    },
    {
      id: 'terraform',
      key: 'terraform',
      title: 'Terraform',
      quadrant: '3',
      description: 'Primary infrastructure-as-code workflow for platform changes.',
      url: 'https://www.terraform.io/',
      timeline: [
        {
          ringId: 'adopt',
          date: new Date('2026-01-01'),
          moved: 0,
          description: 'Standard provisioning workflow.',
        },
      ],
    },
    {
      id: 'semgrep',
      key: 'semgrep',
      title: 'Semgrep',
      quadrant: '4',
      description: 'Static analysis used in the platform security toolchain.',
      url: 'https://semgrep.dev/',
      timeline: [
        {
          ringId: 'assess',
          date: new Date('2026-01-01'),
          moved: 1,
          description: 'Expanding ruleset coverage across services.',
        },
      ],
    },
  ],
};

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: techRadarApiRef,
    deps: {},
    factory: () => ({
      async load() {
        return techRadarData;
      },
    }),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: storageApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      errorApi: errorApiRef,
      fetchApi: fetchApiRef,
      identityApi: identityApiRef,
      signalApi: signalApiRef,
    },
    factory: deps => UserSettingsStorage.create(deps),
  }),
  ScmAuth.createDefaultApiFactory(),
];
